"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

var _constants = require("../../constants");

var _isSameServiceId = _interopRequireDefault(require("../../utils/isSameServiceId"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 异常数据筛选以及适配galileo监控平台的处理
var stringify = function stringify(obj) {
  return JSON.stringify(obj, null, 2);
};

function getFormattedData(params) {
  // 异常相关数据
  return params.map(function (param) {
    var request = param.request,
        breadcrumbs = param.breadcrumbs,
        exception = param.exception,
        selfStack = param.stacktrace,
        mechanism = param.mechanism,
        message = param.message,
        serviceId = param.serviceId,
        _param$extra = param.extra,
        extra = _param$extra === void 0 ? {} : _param$extra;
    var fixException; // param 里存在 stacktrace 和 mechanism 时，是 Raven 捕获到的未被处理的错误, mechanism 存在着错误相关信息

    if (selfStack && mechanism) {
      var firstFrame = selfStack.frames && selfStack.frames[0] || {};
      var ravenFun = firstFrame.function;
      var type = mechanism.type,
          handled = mechanism.handled;
      fixException = {
        stacktrace: selfStack,
        type: type,
        value: "".concat(message, " from ").concat(ravenFun, ". handled: ").concat(handled) || 'unknown'
      }; // param 里只存在 stacktrace 时，是用户自定义错误 kepler.captureException()
    } else if (selfStack) {
      fixException = {
        stacktrace: selfStack,
        type: 'User defined:',
        value: "".concat(message) || 'unknown'
      };
    } // exception保存着监控目标异常信息


    if (exception) {
      fixException = exception.values.slice().pop();
    }

    var _fixException = fixException,
        exceptionType = _fixException.type,
        exceptionValue = _fixException.value,
        exceptionStack = _fixException.stacktrace; // 将异常堆栈和用户路径由近及远的顺序

    var fixBreadcrumbs = breadcrumbs ? breadcrumbs.values.slice().reverse() : [];
    var fixExceptionStack = {
      frames: exceptionStack.frames.slice().reverse()
    };
    return {
      serviceId: serviceId,
      message: stringify({
        pageUrl: request.url,
        // 当前页面地址
        userAgent: request.headers['User-Agent'],
        // 浏览器信息
        exceptionMessage: "".concat(exceptionType, ": ").concat(exceptionValue),
        // 异常描述
        extra: extra,
        userBreadcrumbs: fixBreadcrumbs // 用户操作路径

      }),
      exception_stack: stringify(fixExceptionStack),
      // 异常堆栈
      datetime: Date.now() // 异常触发时间

    };
  });
}

var format = function format(next) {
  return function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var originalData = params.data.filter(_isSameServiceId.default);
    next(Object.assign({}, params, {
      url: "".concat(_constants.SERVER_URL, "/log/").concat(_constants.ROOT),
      data: getFormattedData(originalData),
      originalData: originalData
    }));
  };
};

var _default = format;
exports.default = _default;